import { Trans } from '@lingui/react/macro';

import { Button, LinkButton } from '@/components/buttons';
import { Results } from '@/components/Results';
import { C99_SUPPORT_HOME_URL } from '@/constants/support-urls';
import { ROUTES } from '@/router';

const Error500 = () => {
  return (
    <Results
      status="error"
      title={<Trans>System error</Trans>}
      subtitle={
        <Trans>
          Oops, something went wrong. Try to refresh the page or please contact us if the problem
          persists. Sorry about that. We've logged the error for review.
        </Trans>
      }
      extra={
        <div className="flex flex-col gap-2">
          <Button variant="primary" onClick={() => location.reload()}>
            <Trans>Reload the page</Trans>
          </Button>
          <LinkButton to={ROUTES.app.path}>
            <Trans>Go to the homepage</Trans>
          </LinkButton>
          <LinkButton to={C99_SUPPORT_HOME_URL} target="_blank">
            <Trans>Visit the support center</Trans>
          </LinkButton>
        </div>
      }
      isFullPage
    />
  );
};

export default Error500;
